import React from 'react';

import svg from './assets/icons-32-account-member.svg';
import type { IconProps } from './SvgIcon';
import { SvgIcon } from './SvgIcon';

export const IconUserMember = (props: IconProps) => (
  <SvgIcon {...props} src={svg} testId="icon-user-member" />
);
